<header style="z-index: 200;display: block;box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.07);border-bottom: 1px solid #e0e0e0;width: 100vw;height: var(--app-bar-height);position: fixed !important;top: 0;right: 0;left: 0;">
  <app-bar
  #bar
  id="barComponent"
  style="padding-left: 16px;padding-right: 16px;width: var(--max-width);height: var(--app-bar-height);margin: 0 auto;max-width: var(--max-width);display: grid;grid-template-columns: max-content 1fr;grid-template-rows: var(--app-bar-height);grid-auto-flow: column;grid-auto-columns: max-content;justify-items: end;align-items: center;justify-content: center;">
  </app-bar>
</header>

<!--<mat-progress-bar
*ngIf="loading$ | async"
mode="indeterminate"
style="
  display: block;
  width: 100%;
  height: 4px;
  z-index: 300;
  position: fixed;
  top: var(--app-bar-height);
  left: 0;
  right: 0;
">
</mat-progress-bar>-->

<main
style="
  display: block;
  position: relative;
  width: 100%;
  height: auto;
"
[@routeAnimations]="getRouteAnimationData()">
  <router-outlet>
  </router-outlet>
</main>

<div class="footer"
waIntersectionObserver
waIntersectionThreshold="0"
(waIntersectionObservee)="footerIntersection($event)"
[class.hidden]="hideFooter">
  <ng-template #footerComponent></ng-template>
</div>

<ng-container *ngIf="!class || (class && class.includes('web-landscape') === true)">
  <div style="position:fixed;z-index:100;right:32px;bottom:32px;" class="fab-container" [class]="class">
    <button
    mat-fab
    id="floatingActionButton1"
    class="fab fab-contact"
    aria-label="Kontakt"
    color="primary"
    (click)="openContactPopupForm()"
    style="margin-bottom:16px;display:flex;align-items:center;justify-content:center;">
      <img
      src="assets/icons/mail-white_FILL1_wght400_GRAD0_opsz20.svg"
      width="24"
      height="24"
      alt="Google Bewertungen löschen: Icon (Kontakt)">
    </button>
    <button
    mat-fab
    id="floatingActionButton2"
    class="fab fab-whatsapp"
    aria-label="WhatsApp"
    (click)="openUrl('https://api.whatsapp.com/send?phone=4916097211227&text=Hallo%20Herr%20Schulz%2C%20ich%20ben%C3%B6tige%20zus%C3%A4tzliche%20Information...')"
    style="margin-bottom:16px;display:flex;align-items:center;justify-content:center;">
      <img
      class="fab-icon"
      ngSrc="assets/icons/whatsapp.svg"
      width="56"
      height="56"
      style="width:56px;height:56px;"
      priority
      alt="Google Rezensionen löschen: Icon (WhatsApp)">
    </button>
    <button
    mat-fab
    id="floatingActionButton3"
    class="fab fab-phone"
    aria-label="Anrufen"
    (click)="call('tel:+493029681118')"
    style="display:flex;align-items:center;justify-content:center;">
      <img
      src="assets/icons/call-white_FILL1_wght400_GRAD0_opsz20.svg"
      width="24"
      height="24"
      alt="Google Bewertungen löschen: Icon (Telefon)">
    </button>
  </div>
</ng-container>

<div
class="scrim"
style="width: 100vw;height: calc(100vh - var(--app-bar-height));position: fixed;display: none;top: var(--app-bar-height);z-index: -1;">
</div>

<router-outlet name="auftragOutlet">
</router-outlet>

<router-outlet name="anfrageOutlet">
</router-outlet>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Rechtsanwalt Imanuel Schulz: Google Rezensionen löschen",
    "description": "Das treibt uns an  Nach der frühen Gründung der Rechtsanwaltskanzlei sind bei uns seit der Zeit der Online-Bewertungen auch immer Sorgen um den öffentlichen Ruf mit einhergegangen. Denn von mittlerweile tausenden Mandanten spiegeln eine sehr kleine Anzahl an negativen Bewertungen nicht das durchschnittliche Meinungsbild wider.  Vielmehr handelt es sich sehr oft um willkürliche Launen, von denen der Erfolg oder der im schlimmsten Fall der Niedergang eines Unternehmens abhängt. Wir hörten uns bei Freunden und Bekannten um und unterhielten uns mit vielen, die ein Unternehmen in irgendeiner Form haben. Sei es eine Praxis, ein Restaurant oder ein anderes Geschäft: Alle klagten über die Hilflosigkeit gegenüber zufälligen Kunden und Situationen gegenüber Google und Co.  Ungerechte Bewertungen  Die vielen Kunden, die zufrieden waren, schreiben in der Regel keine Bewertung. So kommt schnell das negative Bild eines Geschäfts zustande, das nicht fair erscheint. An der persönlichen Meinung eines Einzelnen orientieren sich heutzutage die Allermeisten. Eine Bewertung zu einer bestimmten Erfahrung abzugeben ohne die andere Seite zu hören, gleicht unserer Meinung nach einem Gericht ohne den Angeklagten zu hören. Zudem gibt es oft anonyme Bewertungen, dessen Inhalt gar nicht nachvollzogen werden kann oder ähnliche Bewertungen, bei denen viele denken, man ist im Internet nicht wie im wahren Leben vor den banalsten Ungerechtigkeiten geschützt. Von Anfang an verfolgten wir die Entwicklung der Rechtsprechung, die nun eine Richtung erkennen lässt, zum Glück mit Tendenz für den Bewerteten.  Bewährtes Vorgehen  Mit steigender Bedeutung des Bewertungsdschungels konnten wir nach und nach erfolgreich alle Tücken und Probleme lösen. Wir haben zum Glück herausgefunden, wie man als Unternehmer dem ganzen Bewertungswahn nicht hilflos ausgeliefert ist und wir wissen, wie wir den Bewertungsportalen und Kunden Grenzen setzen können. Nur, weil man im Internet eine gewisse Anonymität genießt, kann der Bewertende nicht einfach verleumden oder falsche Tatsachen behaupten und Google kann das nicht einfach ignorieren.  So konnten wir bis jetzt oft 90% der negativen Bewertungen löschen lassen: Mit dem richtigen Umgang mit Bewertungen von Anfang an gepaart mit viel Erfahrung und persönlichem Interesse, Google und Co. zu zeigen, dass sie sich auch und gerade hier an die normalen Spielregeln wie im echten Leben zu halten haben. Denn hinter den bewerteten Unternehmen stecken auch echte Menschen.   Web: https://dein-ruf.de Email: info@dein-ruf.de Tel.: +49 (0) 800 80 00 08 9 WhatsApp: +49 (0) 160 97 21 12 27  Social Media: https://twitter.com/deinrufberlin https://www.facebook.com/deinrufberlin https://www.linkedin.com/company/deinrufberlin https://www.pinterest.de/deinrufberlin https://www.instagram.com/deinrufberlin",
    "thumbnailUrl": "https://i.ytimg.com/vi/yGDPSkbnC7M/default.jpg",
    "uploadDate": "2020-09-25T11:18:38Z",
    "duration": "PT25S",
    "embedUrl": "https://www.youtube.com/embed/yGDPSkbnC7M",
    "interactionCount": "50959"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Google Rezensionen löschen vom Anwalt: Experteninterview auf Galileo ProSieben",
    "description": "Web: https://dein-ruf.de Email: info@dein-ruf.de Tel.: +49 (0) 800 80 00 08 9 WhatsApp: +49 (0) 160 97 21 12 27  Social Media: https://twitter.com/deinrufberlin https://www.facebook.com/deinrufberlin https://www.linkedin.com/company/deinrufberlin https://www.pinterest.de/deinrufberlin https://www.instagram.com/deinrufberlin",
    "thumbnailUrl": "https://i.ytimg.com/vi/AYNP0R8lgU8/default.jpg",
    "uploadDate": "2020-10-28T06:05:12Z",
    "duration": "PT6M24S",
    "embedUrl": "https://www.youtube.com/embed/AYNP0R8lgU8",
    "interactionCount": "2780"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Jameda Bewertungen - Ärzte wehren sich",
    "description": "“Fast jede Bewertung ist angreifbar mit der richtigen juristischen Strategie. Mein Team und ich kennen alle Tricks von und gegen Jameda und Co.”  Rechtsanwalt Imanuel Schulz https://dein-ruf.de",
    "thumbnailUrl": "https://i.ytimg.com/vi/d30GYCCDqwg/default.jpg",
    "uploadDate": "2021-04-21T06:30:51Z",
    "duration": "PT2M1S",
    "embedUrl": "https://www.youtube.com/embed/d30GYCCDqwg",
    "interactionCount": "250"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Google Rezension löschen lassen vom Anwalt - Tipps und Tricks gegen negative Google Rezensionen",
    "description": "Google Rezension löschen - Google Bewertung löschen vom Anwalt für Reputationsschutz Wir sind als Anwälte spezialisiert auf das Thema: Google Rezension löschen  Wir löschen negative Rezension und Verleumdungen bei Google, Jameda, Kununu und Co. Fast jede negative Rezension ist angreifbar, mit der richtigen juristischen Strategie. Wir kennen alle Tricks von und gegen Google und Co.  Kann man jede Google Rezension löschen lassen?  Ja! Grundsätzlich kann man jede Google Rezension löschen. Dabei ist grundsätzlich irrelevant, ob es sich bei der negativen Rezension um eine reine Meinungsäußerung handelt oder gar um eine anonyme Rezension ohne Inhalt. Ob eine negative Rezension tatsächlich rechtmäßig ist, wird nicht etwa von Google, dem Anwalt oder dem Rezensenten entschieden. Vielmehr wird dies in einem einheitlichen von der Rechtsprechung vorgegebenen Verfahren geprüft („Jameda-II“-BGH-Urteil vom 1. März 2016 Az. IV ZR 34/15). Diese Urteil war entscheidend für die Rechte wie man Google Rezensionen löschen lassen kann. Der Portalbetreiber muss auf Beschwerden mit einem solchen Prüfverfahren reagieren und haftet für jede negative Google Rezension selbst, sobald die Beschwerde erfolgt ist. Erst nach Abschluss des Prüfverfahrens kann eine abschließende Einschätzung über die Rechtmäßigkeit der negativen Google Rezension erfolgen. Aber auch rechtmäßige Bewertungen und Rezensionen müssen regelmäßig gelöscht werden, wenn Google sich nicht an den Ablauf des Prüfverfahrens hält oder der Bewerter der sich nicht an die Regeln des Prüfverfahrens hält. Deshalb kann man grundsätzlich jede negative Google Rezension löschen lassen. Das Prüfverfahren geht in den allermeisten Fällen zugunsten des Betroffenen aus, wenn richtig juristisch argumentiert wird. Die meisten Verfasser von Bewertungen sind keine Juristen und denken beim Schreiben nicht darüber nach, dass sie jede Behauptung beweisen müssen, wenn es hart auf hart kommt. Der Rezensent ist als juristischer Laie nicht auf Augenhöhe mit einem Rechtsanwalt, der auf das Thema „Google Rezension löschen“ spezialisiert ist. Als medizinischer Laie diskutiert man auch nicht mit einem Arzt über die richtige Art und Weise, ein Krebsgeschwür zu operieren. Aber selbst, wenn der Rezensent sich einen Anwalt nehmen würde, dann läge die Beweislast für alle Tatsachen in der negativen Google Rezension immer noch bei ihm. Sie merken: Die Chancen, als Verfasser der Bewertung ein Prüfverfahren zu bestehen, ist nicht einfach. Es ist verdammt leicht, eine negative Google Rezension in die Welt zu setzen. Es ist aber sehr viel schwieriger, diese Rezension zu verteidigen, wenn sich der Betroffene dagegen mit anwaltlicher Hilfe wehrt.  Web: https://dein-ruf.de Email: Anwalt@dein-ruf.de Tel.: +49 (0) 800 80 00 08 9 WhatsApp: +49 (0) 160 97 21 12 27  Social Media: https://twitter.com/deinrufberlin https://www.facebook.com/deinrufberlin https://www.linkedin.com/company/deinrufberlin https://www.pinterest.de/deinrufberlin https://www.instagram.com/deinrufberlin",
    "thumbnailUrl": "https://i.ytimg.com/vi/DBDudSCkwzM/default.jpg",
    "uploadDate": "2020-10-09T11:23:15Z",
    "duration": "PT2M24S",
    "embedUrl": "https://www.youtube.com/embed/DBDudSCkwzM",
    "interactionCount": "379"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Google Rezension löschen – So funktionierts (Erklärvideo)",
    "description": "Google Rezension löschen - Google Bewertung löschen vom Anwalt für Reputationsschutz Wir sind als Anwälte spezialisiert auf das Thema: Google Rezension löschen  Wir löschen negative Rezension und Verleumdungen bei Google, Jameda, Kununu und Co. Fast jede negative Rezension ist angreifbar, mit der richtigen juristischen Strategie. Wir kennen alle Tricks von und gegen Google und Co.  Kann man jede Google Rezension löschen lassen?  Ja! Grundsätzlich kann man jede Google Rezension löschen. Dabei ist grundsätzlich irrelevant, ob es sich bei der negativen Rezension um eine reine Meinungsäußerung handelt oder gar um eine anonyme Rezension ohne Inhalt. Ob eine negative Rezension tatsächlich rechtmäßig ist, wird nicht etwa von Google, dem Anwalt oder dem Rezensenten entschieden. Vielmehr wird dies in einem einheitlichen von der Rechtsprechung vorgegebenen Verfahren geprüft („Jameda-II“-BGH-Urteil vom 1. März 2016 Az. IV ZR 34/15). Diese Urteil war entscheidend für die Rechte wie man Google Rezensionen löschen lassen kann. Der Portalbetreiber muss auf Beschwerden mit einem solchen Prüfverfahren reagieren und haftet für jede negative Google Rezension selbst, sobald die Beschwerde erfolgt ist. Erst nach Abschluss des Prüfverfahrens kann eine abschließende Einschätzung über die Rechtmäßigkeit der negativen Google Rezension erfolgen. Aber auch rechtmäßige Bewertungen und Rezensionen müssen regelmäßig gelöscht werden, wenn Google sich nicht an den Ablauf des Prüfverfahrens hält oder der Bewerter der sich nicht an die Regeln des Prüfverfahrens hält. Deshalb kann man grundsätzlich jede negative Google Rezension löschen lassen. Das Prüfverfahren geht in den allermeisten Fällen zugunsten des Betroffenen aus, wenn richtig juristisch argumentiert wird. Die meisten Verfasser von Bewertungen sind keine Juristen und denken beim Schreiben nicht darüber nach, dass sie jede Behauptung beweisen müssen, wenn es hart auf hart kommt. Der Rezensent ist als juristischer Laie nicht auf Augenhöhe mit einem Rechtsanwalt, der auf das Thema „Google Rezension löschen“ spezialisiert ist. Als medizinischer Laie diskutiert man auch nicht mit einem Arzt über die richtige Art und Weise, ein Krebsgeschwür zu operieren. Aber selbst, wenn der Rezensent sich einen Anwalt nehmen würde, dann läge die Beweislast für alle Tatsachen in der negativen Google Rezension immer noch bei ihm. Sie merken: Die Chancen, als Verfasser der Bewertung ein Prüfverfahren zu bestehen, ist nicht einfach. Es ist verdammt leicht, eine negative Google Rezension in die Welt zu setzen. Es ist aber sehr viel schwieriger, diese Rezension zu verteidigen, wenn sich der Betroffene dagegen mit anwaltlicher Hilfe wehrt.  Web: https://dein-ruf.de Email: info@dein-ruf.de Tel.: +49 (0) 800 80 00 08 9 WhatsApp: +49 (0) 160 97 21 12 27  Social Media: https://twitter.com/deinrufberlin https://www.facebook.com/deinrufberlin https://www.linkedin.com/company/deinrufberlin https://www.pinterest.de/deinrufberlin https://www.instagram.com/deinrufberlin",
    "thumbnailUrl": "https://i.ytimg.com/vi/sa7uM_8ISfc/default.jpg",
    "uploadDate": "2020-09-21T12:40:40Z",
    "duration": "PT2M1S",
    "embedUrl": "https://www.youtube.com/embed/sa7uM_8ISfc",
    "interactionCount": "50999"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Vom Auftrag bis zur Löschung - Google Rezension löschen vom Anwalt",
    "description": "Das Mandat beim Anwalt - Google Rezensionen Löschen lassen Sie wollen eine negative Rezension zum Beispiel bei Google bei uns in Auftrag geben.  In diesem Video erklären wir Ihnen,  wie Sie uns beauftragen,  wir wir arbeiten und wie die gesamte Mandatierung abläuft bis zur Löschung einer Bewertung.   Web: https://dein-ruf.de Email: info@dein-ruf.de Tel.: +49 (0) 800 80 00 08 9 WhatsApp: +49 (0) 160 97 21 12 27  Social Media: https://twitter.com/deinrufberlin https://www.facebook.com/deinrufberlin https://www.linkedin.com/company/deinrufberlin https://www.pinterest.de/deinrufberlin https://www.instagram.com/deinrufberlin",
    "thumbnailUrl": "https://i.ytimg.com/vi/lWTmraotxr4/default.jpg",
    "uploadDate": "2020-10-21T22:27:25Z",
    "duration": "PT2M47S",
    "embedUrl": "https://www.youtube.com/embed/lWTmraotxr4",
    "interactionCount": "2381"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Illegale Löschagenturen: Agenturen verstoßen gegen das Gesetz",
    "description": "",
    "thumbnailUrl": "https://i.ytimg.com/vi/R50q6LJikrc/default.jpg",
    "uploadDate": "2022-08-08T13:27:20Z",
    "duration": "PT3M6S",
    "embedUrl": "https://www.youtube.com/embed/R50q6LJikrc",
    "interactionCount": "7968"
  }
</script>

<script type="application/ld+json">
  {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "Daumen runter! Das üble Geschäft mit den Internet-Bewertungen",
    "description": "Hotelier Peter Kirchberger aus Bayrischzell bekam immer wieder Anrufe und Mails mit dem Angebot, schlechte Online-Bewertungen seines Hotels löschen zu lassen - obwohl er kaum welche hatte. Als er dankend ablehnt, trudeln plötzlich jede Menge schlechter Bewertungen ein - und wieder kommt das Angebot, diese gegen Bezahlung löschen zu lassen.",
    "thumbnailUrl": "https://i.ytimg.com/vi/-4hfPvdpjeQ/default.jpg",
    "uploadDate": "2022-08-01T08:44:12Z",
    "duration": "PT5M34S",
    "embedUrl": "https://www.youtube.com/embed/-4hfPvdpjeQ",
    "interactionCount": "5"
  }
</script>


<ng-container *ngIf="class && class.includes('web-landscape') === false">
  <app-bottom-navigation-bar>
  </app-bottom-navigation-bar>
</ng-container>